import { render } from "./CalendarArrowLeftIcon.vue?vue&type=template&id=358edd76"
import script from "./CalendarArrowLeftIcon.vue?vue&type=script&lang=js"
export * from "./CalendarArrowLeftIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__